document.addEventListener('DOMContentLoaded', function () {
  try {
    // wait until the form is loaded
    const checkFormLoaded = setInterval(() => {
      const formEmbed = document.querySelector('form-embed#app-embed');
      if (formEmbed && formEmbed.shadowRoot) {
        clearInterval(checkFormLoaded); // Stop checking once the form is loaded

        const applyCustomStyles = () => {
          // access form elements within the shadow DOM
          const inputs = formEmbed.shadowRoot.querySelectorAll('form *');

          inputs.forEach((value) => {
            // Skip the button for form submit
            if (value.getAttribute('data-testid') === 'btn-form-submit') return;

            if (['textarea', 'input', 'button'].includes(value.tagName.toLowerCase())) {
              value.style.border = '1px solid #070E3E';
              value.style.borderRadius = value.tagName.toLowerCase() === 'textarea' ? '10px' : '100px';
            }

            // Set accent color to aston blue for radio inputs
            if (value.type === 'radio' || value.type === 'checkbox') {
              value.style.accentColor = 'rgb(7, 14, 62)';
            }
          });

          const inputContainers = formEmbed.shadowRoot.querySelectorAll('div._formFieldContainer_1ydxd_5');
          inputContainers.forEach((container) => {
            const input = container.querySelector('input, textarea');
            const label = container.querySelector('label');

            if (input && label) {
              label.style.color = '#161E5466';
              label.style.fontFamily = 'Inter';
              label.style.fontSize = '13px';
              label.style.fontWeight = '400';

              // Check if the label ID matches one of the specified IDs
              const labelId = label.id; // Get the ID of the current label
              const targetIds = [
                'label-custom#how_many_sales_people_do_you_have_on_your_team',
                'label-custom#what_market_do_you_service_what_is_your_geographic_reach',
                'label-custom#please_provide_a_short_description_about_your_company',
              ];

              if (targetIds.includes(labelId) && window.innerWidth <= 540) {
                label.style.top = '110px'; // top is 110px for specified labels in become a dealer page
              } else {
                label.style.top = '90px'; // Default top for other labels for any other pages
              }

              if (input.type !== 'radio') {
                const newLabelDiv = document.createElement('div');
                newLabelDiv.textContent = label.textContent;
                newLabelDiv.style.cssText = `
                  color: #070E3E;
                  padding-top: 26px;
                  font-family: Inter;
                  font-size: 16px;
                  font-weight: 400;
                  line-height: 23.52px;
                  letter-spacing: -0.02em;
                  margin-bottom: 24px;
                `;

                container.insertBefore(newLabelDiv, input);
              }
            }
          });

          const formContainer = formEmbed.shadowRoot.querySelector('section[data-testid="form-container"]');
          if (formContainer) {
            formContainer.style.cssText = `
              width: 100%;
              max-width: 640px;
              margin: 0 auto;
            `;
          }

          const fieldSets = formEmbed.shadowRoot.querySelectorAll('fieldset');

          fieldSets.forEach((fieldset) => {
            const legend = fieldset.querySelector(':scope > legend');
            if (legend) {
              legend.style.cssText = `
                color: #070E3E;
                padding-top: 26px;
                font-family: Inter;
                font-size: 16px;
                font-weight: 400;
                line-height: 23.52px;
                letter-spacing: -0.02em;
                padding-bottom: 24px;
                -webkit-font-smoothing: auto;
              `;
            }

            const labels = fieldset.querySelectorAll(':scope > div > label');

            labels.forEach((label) => {
              label.style.marginBottom = '14px';
              const span = label.querySelector(':scope > span');
              if (span) {
                span.style.cssText = `
                  margin-left: 2px;
                  color: #070E3E;
                  font-family: Inter;
                  font-size: 16px;
                  font-weight: 400;
                  -webkit-font-smoothing: auto;
                `;
              }
            });
          });

          const submitButton = formEmbed.shadowRoot.querySelector('button[data-testid="btn-form-submit"]');

          if (submitButton) {
            const applyButtonStyles = () => {
              if (window.innerWidth <= 540) {
                submitButton.style.width = 'auto';
              } else {
                submitButton.style.width = 'fit-content';
              }
            };

            // apply styles on load
            applyButtonStyles();

            // reapply styles on window resize
            window.addEventListener('resize', applyButtonStyles);

            submitButton.style.cssText += `
              border-radius: 100px;
              background-color: #070E3E;
              color: #FBFCFF;
              font-family: Inter;
              font-size: 12px;
              font-weight: 600;
              margin-top: 36px;
              letter-spacing: 0.17em;
            `;
          }

          const paragraphs = formEmbed.shadowRoot.querySelectorAll('p._label_1yit2_10');

          paragraphs.forEach((p) => {
            p.style.cssText = `
              color: #070E3E;
              font-family: Inter;
              font-size: 16px;
              font-weight: 400;
              line-height: 23.52px;
              letter-spacing: -0.02em;
              margin-bottom: 24px;
              padding-top: 26px;
            `;
          });

          // show the form once styling is applied
          formEmbed.style.visibility = 'visible';
        };

        // apply custom styles with a slight delay to ensure all elements are accessible
        setTimeout(applyCustomStyles, 100);
      }
    }, 100);
  } catch (error) {
    console.error('Something went wrong! Please reload the page.', error);
  }
});
